import { gettext } from '@eventbrite/i18n';
import classnames from 'classnames';
import React from 'react';
import { useGlobalNavContext } from '../../state';
import { Logo, MobileDropdown, NavLink, SearchBar } from '../common';
import { NavItemType } from '../types';
import styles from './MobileNav.module.scss';

const MobileNav = () => {
    const { positionSticky, env, navigation } = useGlobalNavContext();
    const { mobile } = navigation ?? {};
    const dropdownItems = mobile as NavItemType[];
    const isSticky = positionSticky?.mobile ? 'mobileSticky' : '';
    const navClass = classnames(styles.nav, isSticky);

    return (
        <nav data-testid="mobile-nav" className={navClass}>
            <ul className={styles.root}>
                <li className={styles.logo}>
                    <Logo />
                </li>
                <li className={styles.searchBar}>
                    <SearchBar />
                </li>

                <li className={styles.right}>
                    <ul className={styles.linkContainer}>
                        <li className={styles.listLink}>
                            <NavLink
                                path={env?.signinUrl ?? '/signin/'}
                                text={gettext('Log In')}
                                className={styles.login}
                            />
                        </li>
                        <li className={styles.listLink}>
                            <NavLink
                                path={env?.signupUrl ?? '/signin/signup/'}
                                text={gettext('Sign Up')}
                                className={styles.signup}
                            />
                        </li>
                        <MobileDropdown dropdownItems={dropdownItems} />
                    </ul>
                </li>
            </ul>
        </nav>
    );
};

export default MobileNav;
